import { render, staticRenderFns } from "./newBillOverseasSSubmitView.vue?vue&type=template&id=d637384c&"
import script from "./newBillOverseasSSubmitView.vue?vue&type=script&lang=js&"
export * from "./newBillOverseasSSubmitView.vue?vue&type=script&lang=js&"
import style0 from "./newBillOverseasSSubmitView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d637384c')) {
      api.createRecord('d637384c', component.options)
    } else {
      api.reload('d637384c', component.options)
    }
    module.hot.accept("./newBillOverseasSSubmitView.vue?vue&type=template&id=d637384c&", function () {
      api.rerender('d637384c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSSubmitView.vue"
export default component.exports